import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 定义通用api前缀
//其知网后台接口url前缀(本地)
// var webRoot = 'http://192.168.101.7/index.php';
//其知网后台后台接口url前缀(线上)
// var webRoot = 'https://zlbb.qzhip.com/index.php';
var webRoot = 'http://zlbb.qzhip.test/index.php';


// 专利管理
// 数据更新-账户列表
export const AdminPatentPageCount = (params) => { return req("post", "/patent/monitor/getAdminPatentPageCount", params) };
// 数据更新-角色列表
export const getRoleList = (params) => { return req("post", "/patent/role/getRoleList", params) };

// 监控大厅-搜索
export const searchPatent = (params) => { return req("post", "/patent/search/getSearchPatentPage", params) };
// 监控大厅-base模式搜索
export const searchBasePatent = (params) => { return req("post", "/patent/search/getSearchPatentBasePage", params) };
// 监控大厅-filter模式搜索
export const searchFilterPatent = (params) => { return req("post", "/patent/search/getSearchPatentFilterPage", params) };
// 监控大厅-法律状态
export const searchLegalStatus = (params) => { return req("post", "/patent/search/getSearchLegalStatus", params) };
// 监控大厅-模糊查询申请人
export const searchApplicant = (params) => { return req("post", "/patent/search/getSearchApplicant", params) };
// 监控大厅-模糊查询发明人
export const searchInventor = (params) => { return req("post", "/patent/search/getSearchInventor", params) };
// 监控大厅-查询默认申请人
export const getDefaultApplicant = (params) => { return req("post", "/patent/search/getDefaultApplicant", params) };
// 监控大厅-查询默认申请人
export const getDefaultInventor = (params) => { return req("post", "/patent/search/getDefaultInventor", params) };
// 监控大厅-导出勾选的数据
export const exportCheck = (params) => { return req("post", "/patent/search/exportCheck", params) };
// 监控大厅-导出满足条件的数据
export const exportAll = (params) => { return req("post", "/patent/search/exportAll", params) };
// 监控大厅-删除专利(单个)
export const deletePatent = (params) => { return req("post", "/patent/search/delPatent", params) };
// 监控大厅-删除专利(勾选)
export const deleteCheckPatent = (params) => { return req("post", "/patent/search/delCheckPatent", params) };
// 监控大厅-查询专利著录信息
export const getPatentRecord = (params) => { return req("post", "/patent/monitor/getPatentRecord", params) };
// 监控大厅-查询专利权利要求书
export const getPatentClaims = (params) => { return req("post", "/patent/monitor/getPatentClaims", params) };
// 监控大厅-查询专利说明书
export const getPatentManual = (params) => { return req("post", "/patent/monitor/getPatentManual", params) };
// 监控大厅-查询专利法律状态
export const getPatentLegal = (params) => { return req("post", "/patent/monitor/getPatentLegal", params) };
// 监控大厅-查询专利费用信息
export const getPatentFee = (params) => { return req("post", "/patent/monitor/getPatentFee", params) };
// 监控大厅-查询导出模板列表
export const getExportTemp = (params) => { return req("post", "/patent/monitor/getExportTemp", params) };
// 监控大厅-添加自定义导出模板
export const addExportTemp = (params) => { return req("post", "/patent/monitor/addExportTemp", params) };
// 监控大厅-导出文件
export const downloadExcel = (params) => { return req("post", "/patent/monitor/downloadExcel", params) };
// 监控大厅-查询专利类型数量统计
export const getPatentTypeGroup = (params) => { return req("post", "/patent/search/getPatentTypeGroup", params) };
// 监控大厅-查询专利有效性数量统计
export const getPatentLegalGroup = (params) => { return req("post", "/patent/search/getPatentLegalGroup", params) };
// 监控大厅-查询专利法律事件数量统计
export const getPatentEventGroup = (params) => { return req("post", "/patent/search/getPatentEventGroup", params) };
// 监控大厅-查询专利申请日数量统计
export const getPatentApplyGroup = (params) => { return req("post", "/patent/search/getPatentApplyGroup", params) };
// 监控大厅-查询专利公开(公告)日数量统计
export const getPatentDocumentGroup = (params) => { return req("post", "/patent/search/getPatentDocumentGroup", params) };
// 监控大厅-查询专利转让年份数量统计
export const getPatentTransferYearGroup = (params) => { return req("post", "/patent/search/getPatentTransferYearGroup", params) };
// 监控大厅-查询专利许可年份数量统计
export const getPatentLicenseYearGroup = (params) => { return req("post", "/patent/search/getPatentLicenseYearGroup", params) };
// 监控大厅-查询专利所属领域数量统计
export const getPatentTechnologyGroup = (params) => { return req("post", "/patent/search/getPatentTechnologyGroup", params) };
// 监控大厅-查询专利申请人数量统计
export const getPatentApplicantGroup = (params) => { return req("post", "/patent/search/getPatentApplicantGroup", params) };
// 监控大厅-查询专利发明人数量统计
export const getPatentInventorGroup = (params) => { return req("post", "/patent/search/getPatentInventorGroup", params) };
// 监控大厅-查询专利申请人类型数量统计
export const getPatentApplicantTypeGroup = (params) => { return req("post", "/patent/search/getPatentApplicantTypeGroup", params) };
// 监控大厅-查询近期待缴专利列表
export const getNearNeedPayFee = (params) => { return req("post", "/patent/search/nearNeedPayFee", params) };
// 监控大厅-导出近期待缴专利列表
export const downloadNearNeedPayFee = (params) => { return req("post", "/patent/monitor/downloadNearNeedPayFee", params) };
// 监控大厅-查询专利PDF文件
export const getPatentPDF = (params) => { return req("post", "/patent/monitor/getPatentPDF", params) };
// 监控大厅-查询账户发票信息
export const getAdminInvoice = (params) => { return req("post", "/patent/admin/getAdminInvoice", params) };
// 监控大厅-查询账户发票信息
export const addAdminInvoice = (params) => { return req("post", "/patent/admin/addAdminInvoice", params) };
// 监控大厅-查询账户发票信息
export const createOrder = (params) => { return req("post", "/patent/order/createOrder", params) };

// 专利检索-按条件检索
export const patentRetrieval = (params) => { return req("post", "/patent/search/patentRetrieval", params) };
// 专利检索-专利详情
export const getPatentInfo = (params) => { return req("post", "/patent/search/patentInfo", params) };
// 专利检索-添加监控(单个)
// export const addPatentMonitor = (params) => { return req("post", "/patent/search/addPatentMonitor", params) };
export const addPatentMonitor = (params) => { return req("post", "/patent/search/addPatentMonitorV2", params) };
// 专利检索-添加监控(勾选)
export const addCheckPatentMonitor = (params) => { return req("post", "/patent/search/addCheckMonitor", params) };

// 检索任务
// 检索任务-检索值列表
export const searchValueList = (params) => { return req("post", "/patent/search/getSearchValueList", params) };
// 检索任务-添加检索值
export const addSearchValue = (params) => { return req("post", "/patent/search/addSearchValue", params) };
// 检索任务-删除检索值(单个)
export const delSearchValue = (params) => { return req("post", "/patent/search/delSearchValue", params) };
// 检索任务-删除检索值(勾选)
export const delCheckSearchValue = (params) => { return req("post", "/patent/search/delCheckSearchValue", params) };

// 个人中心-获取个人信息
export const getAdminInfo = (params) => { return req("post", "/patent/admin/getAdminInfo", params) };
// 个人中心-修改个人信息
export const editAdminInfo = (params) => { return req("post", "/patent/admin/editAdminInfo", params) };
// 个人中心-修改密码
export const resetAdminPwd = (params) => { return req("post", "/patent/admin/resetPassword", params) };
// 个人中心-获取邮箱验证码
export const getBindEmailCode = (params) => { return req("post", "/patent/admin/getBindEmailCode", params) };
// 个人中心-绑定邮箱
export const bindEmail = (params) => { return req("post", "/patent/admin/bindEmail", params) };
// 个人中心-获取手机号验证码
export const getBindMobileCode = (params) => { return req("post", "/patent/admin/getBindMobileCode", params) };
// 个人中心-绑定手机号
export const bindMobile = (params) => { return req("post", "/patent/admin/bindMobile", params) };

// 企业管理
// 企业列表
export const getBusinessList = (params) => { return req("post", "/patent/business/getBusinessList", params) };
// 企业编辑
export const editBusiness = (params) => { return req("post", "/patent/business/editBusiness", params) };
// 企业删除
export const delBusiness = (params) => { return req("post", "/patent/business/delBusiness", params) };
// 手动更新企业工商信息
export const updateBusiness = (params) => { return req("post", "/patent/business/updateBusiness", params) };
// 企业-查询企业经营状态数量统计
export const getBusinessStatusGroup = (params) => { return req("post", "/patent/business/getBusinessStatusGroup", params) };
// 企业列表-过滤模式
export const getBusinessFilter = (params) => { return req("post", "/patent/business/getBusinessFilter", params) };
// 企业-查询企业人员规模数量统计
export const getBusinessPersonGroup = (params) => { return req("post", "/patent/business/getBusinessPersonGroup", params) };
// 企业-查询企业参保人数数量统计
export const getBusinessInsuredGroup = (params) => { return req("post", "/patent/business/getBusinessInsuredGroup", params) };
// 企业-查询企业类型数量统计
export const getBusinessTypeGroup = (params) => { return req("post", "/patent/business/getBusinessTypeGroup", params) };
// 企业-查询企业所属行业数量统计
export const getBusinessIndustryGroup = (params) => { return req("post", "/patent/business/getBusinessIndustryGroup", params) };
// 企业-下载企业导入模板
export const getImportTemplate = (params) => { return req("post", "/patent/business/getImportTemplate", params) };

// 专利
// 专利列表
export const getPatentList = (params) => { return req("post", "/patent/business/getPatentList", params) };
// 商标列表-base模式
export const getTradeMarkList = (params) => { return req("post", "/patent/business/getTradeMarkList", params) };
// 商标列表-过滤模式
export const getTradeMarkFilter = (params) => { return req("post", "/patent/business/getTradeMarkFilter", params) };
// 商标-查询商标状态数量统计
export const getMarkStatusGroup = (params) => { return req("post", "/patent/business/getMarkStatusGroup", params) };
// 商标-查询商标申请人数量统计
export const getApplicantGroup = (params) => { return req("post", "/patent/business/getApplicantGroup", params) };
// 商标-搜索条件导出数据
export const exportSearchMark = (params) => { return req("post", "/patent/business/exportSearchMark", params) };
// 商标-商标详情
export const getTradeMarkInfo = (params) => { return req("post", "/patent/business/getTradeMarkInfo", params) };


// 软著列表-base模式
export const getSoftNessList = (params) => { return req("post", "/patent/business/getSoftNessList", params) };
// 软著列表-filter模式
export const getSoftNessFilter = (params) => { return req("post", "/patent/business/getSoftNessFilter", params) };
// 软著列表-查询软著著作权人数量统计
export const getAuthorGroup = (params) => { return req("post", "/patent/business/getAuthorGroup", params) };
// 软著-搜索条件导出数据
export const exportSearchSoft = (params) => { return req("post", "/patent/business/exportSearchSoft", params) };

export const webUrl = 'https://zlbb.qzhip.com/index.php';
// export const webUrl = 'http://zlbb.qzhip.test/index.php';


// WEBPACK FOOTER //
// ./src/api/patentMG.js